module.exports = __webpack_public_path__ + "static/media/tri_sector1.a3ed3cf9.jpg";